import { useCallback, useContext, useEffect, useState } from "react";
import { onlyRoles } from "../../components/authentication/authorizations";
import { UserContext } from "../../components/authentication/Session/UserContext";
import { Role } from "@farmact/model/src/model/Role";

export interface UseRoleReturn {
    role: Role | undefined;
    isLoading: boolean;
    error: any;
    only: (...roles: Role[]) => boolean;
}

export function useRole(): UseRoleReturn {
    const [role, setRole] = useState<Role | undefined>(localStorage.getItem("cachedRole") as Role | undefined);
    const [loading, setLoading] = useState(true);
    const [error] = useState<any>(null);

    const claims = useContext(UserContext).customClaims;

    useEffect(() => {
        if (!claims) {
            return;
        }

        if (claims.defaultCompanyId && claims.roles?.[claims.defaultCompanyId]) {
            setRole(claims.roles[claims.defaultCompanyId]);
            localStorage.setItem("cachedRole", claims.roles[claims.defaultCompanyId]);
            setLoading(false);
            return;
        }

        if (!claims.defaultCompanyId && Object.entries(claims?.customerIds ?? {}).length > 0) {
            setRole(Role.CUSTOMER);
            localStorage.setItem("cachedRole", Role.CUSTOMER);
            setLoading(false);
            return;
        }

        setRole(Role.NOTHING);
        localStorage.setItem("cachedRole", Role.NOTHING);
        setLoading(false);
    }, [claims]);

    const only = useCallback(
        (...roles: Role[]) => {
            const checkAuthorized = onlyRoles(...roles);
            return checkAuthorized(role);
        },
        [role]
    );

    return {
        role,
        isLoading: loading,
        error,
        only,
    };
}
